.header {
  display: flex;
  align-items: center;
  gap: 0.8rem;
  height: var(--tab-bar-height);
  min-height: var(--tab-bar-height);
  background-color: transparent;
  justify-content: space-between;
  width: 100%;
  overflow: hidden;
  padding: 0.8rem 0;

  @media screen and (min-width: $bp-medium) {
    display: none;
  }
}

.left {
  display: flex;
  align-items: center;
  gap: 0.8rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  &[data-with-padding='false'] {
    padding-left: 1.6rem;
  }
}

.right {
  display: flex;
  align-items: center;
  gap: 0.4rem;
  margin-inline-end: 1.2rem;
}

.title {
  font-weight: 500;
  font-size: 1.6rem;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  color: var(--color-grayscale-white);
}

.drawer-container {
  display: block;

  &[data-hide='true'] {
    display: none;
  }

  @media screen and (min-width: $bp-medium) {
    display: none;
  }
}

.mobile-drawer-trigger {
  display: flex;
  padding: 0.8rem;
  justify-content: flex-end;
  align-items: center;
  width: fit-content;

  & > svg {
    transform: rotate(180deg);
  }
}

.action {
  font-weight: 500;
  font-size: 1.4rem;
  margin-inline-end: 0.4rem;
  color: var(--color-primary-crayola);
}

.menu-trigger {
  padding: 1.2rem;
  margin: 0 0.8rem;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;

  & > svg {
    pointer-events: none;
  }

  @media screen and (min-width: $bp-medium) {
    display: none;
  }
}
